import React, { useMemo, useState } from "react";
import RfmModalBase from "./RfmModalBase";

export default function RfmSplitBillModal({ open, onClose, remaining = 0, onApply }) {
  const [count, setCount] = useState(2);

  const each = useMemo(() => {
    const c = Math.max(2, Number(count) || 2);
    return remaining / c;
  }, [remaining, count]);

  const apply = () => {
    onApply?.({ count: Math.max(2, Number(count) || 2) });
    onClose?.();
  };

  return (
    <RfmModalBase
      open={open}
      title="Dividir Cuenta"
      onClose={onClose}
      footer={
        <>
          <button className="rfm-btn rfm-btn-secondary" type="button" onClick={onClose}>Cerrar</button>
          <button className="rfm-btn rfm-btn-primary" type="button" onClick={apply}>
            <i className="bi bi-check-lg" /> Aplicar
          </button>
        </>
      }
    >
      <div className="rfm-form-group">
        <label className="rfm-form-label">Dividir entre</label>
        <div className="rfm-chair-selector">
          <button className="rfm-chair-btn" type="button" onClick={() => setCount((v) => Math.max(2, (Number(v) || 2) - 1))}>
            <i className="bi bi-dash" />
          </button>
          <span className="rfm-chair-count">{count}</span>
          <button className="rfm-chair-btn" type="button" onClick={() => setCount((v) => (Number(v) || 2) + 1)}>
            <i className="bi bi-plus" />
          </button>
        </div>
      </div>

      <div style={{ background: "var(--bg-tertiary)", padding: "1rem", borderRadius: 10, textAlign: "center" }}>
        <div style={{ fontSize: "0.8rem", color: "var(--text-muted)" }}>Cada persona paga</div>
        <div style={{ fontSize: "1.4rem", fontWeight: 700, color: "var(--accent-primary)" }}>
          ${isFinite(each) ? each.toFixed(2) : "0.00"}
        </div>
      </div>
    </RfmModalBase>
  );
}
